import { AuthGuard } from './../auth.guard';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { FuseSharedModule } from '@fuse/shared.module';
import { EstabelecimentoComponent } from './estabelecimento.component';
import { EstabelecimentoListaComponent } from './lista/lista.component';
import { SharedModule } from 'app/shared/shared.module';


const routes = [
    {
        path     : 'auth/estabelecimento',
        component: EstabelecimentoComponent
    }
];

@NgModule({
    declarations: [ EstabelecimentoComponent, EstabelecimentoListaComponent ],
    imports     : [
        RouterModule.forChild(routes),
        FuseSharedModule,
        SharedModule
    ],
    exports: [EstabelecimentoComponent, EstabelecimentoListaComponent]
})
export class EstabelecimentoModule
{}
